import React, { useState } from "react";
import cx from "clsx";
import { usePatientSmsCountQuery } from "../../../../../../../api/patient/usePatientSmsCountQuery";
import styles from "./styles.module.scss";
import { Modal } from "../../../../../../../shared/Modal/Modal";
import { Header } from "./shared/Header";
import { Chat } from "./shared/Chat";

const BADGE_SMS_LIMIT = 99;

/**
 * @param {{
 *  patientId: number;
 * }} param0
 */
export const Inbox = ({ patientId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: countData } = usePatientSmsCountQuery(
    { patientId },
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: true,
    },
  );

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className={cx("blue-btn pull-right", styles.inboxButton)}
      >
        Inbox
        {countData?.unread > 0 && (
          <span className={styles.unreadBadge}>
            {countData.unread > BADGE_SMS_LIMIT
              ? `${BADGE_SMS_LIMIT}+`
              : countData.unread}
          </span>
        )}
      </button>
      {isModalOpen && (
        <Modal
          isOpen
          shouldCloseOnOverlayClick={false}
          onClose={() => setIsModalOpen(false)}
          header={<Header patientId={patientId} />}
          contentClassName={styles.modalContent}
          className={styles.modal}
        >
          <Chat patientId={patientId} />
        </Modal>
      )}
    </>
  );
};
